/**
 * Offices Settings - использует переиспользуемые компоненты настроек
 */
import React from 'react';
import Input from '../../components/ui/Input';
import Icon from '../../components/AppIcon';
import {
  SettingsGroup,
  TextSettings,
  SelectFieldSettings,
} from '../components/settings';

// Хелпер для работы с текстовыми данными
const getTextData = (value) => {
  if (typeof value === 'object' && value !== null) return value;
  return { text: value || '' };
};

export default function OfficesSettings({ data, onChange }) {
  const updateData = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  // Извлекает officeId из URL или возвращает как есть
  const extractOfficeId = (input) => {
    if (!input) return '';

    // Пробуем извлечь из URL
    try {
      const url = new URL(input);
      const pathParts = url.pathname.split('/').filter(Boolean);
      if (pathParts.length > 0) {
        return pathParts[pathParts.length - 1];
      }
    } catch {
      // Не URL, возвращаем как есть
    }

    return input.trim();
  };

  const updateOffice = (index, value) => {
    const newOffices = [...(data?.offices || [])];
    const officeId = extractOfficeId(value);
    newOffices[index] = { ...newOffices[index], officeId, _input: value };
    updateData('offices', newOffices);
  };

  const addOffice = () => {
    const newOffices = [
      ...(data?.offices || []),
      {
        id: Date.now().toString(),
        officeId: '',
        _input: ''
      }
    ];
    updateData('offices', newOffices);
  };

  const removeOffice = (index) => {
    const newOffices = (data?.offices || []).filter((_, i) => i !== index);
    updateData('offices', newOffices);
  };

  return (
    <div className="space-y-6">
      {/* Контент */}
      <SettingsGroup title="Контент">
        <TextSettings
          label="Заголовок"
          value={getTextData(data?.title)}
          onChange={(value) => updateData('title', value)}
          placeholder="Наши кабинеты"
          defaults={{ size: '3xl', weight: 'bold', color: 'foreground' }}
        />
        <TextSettings
          label="Подзаголовок"
          value={getTextData(data?.subtitle)}
          onChange={(value) => updateData('subtitle', value)}
          placeholder="Выберите подходящее пространство"
          defaults={{ size: 'lg', weight: 'normal', color: 'text-secondary' }}
        />
      </SettingsGroup>

      {/* Оформление */}
      <SettingsGroup title="Оформление">
        <SelectFieldSettings
          label="Режим"
          value={data?.mode || 'list'}
          onChange={(value) => updateData('mode', value)}
          mode="grid"
          columns={2}
          options={[
            { value: 'list', label: 'Список', icon: 'LayoutGrid' },
            { value: 'single', label: 'Один кабинет', icon: 'Square' },
          ]}
        />

        <SelectFieldSettings
          label="Вид карточки"
          value={data?.cardStyle || 'compact'}
          onChange={(value) => updateData('cardStyle', value)}
          mode="grid"
          columns={2}
          options={[
            { value: 'compact', label: 'Компактный', icon: 'CreditCard' },
            { value: 'detailed', label: 'Подробный', icon: 'FileText' },
          ]}
        />

        {(data?.mode || 'list') === 'list' && (
          <SelectFieldSettings
            label="Колонки"
            value={data?.columns || 2}
            onChange={(value) => updateData('columns', value)}
            mode="grid"
            columns={3}
            options={[
              { value: 1, label: '1' },
              { value: 2, label: '2' },
              { value: 3, label: '3' },
            ]}
          />
        )}
      </SettingsGroup>

      {/* Кабинеты */}
      <SettingsGroup
        title={`Кабинеты (${(data?.offices || []).length})`}
        rightAction={
          <button
            onClick={addOffice}
            className="flex items-center gap-1 text-xs px-2 py-1 rounded bg-primary/10 text-primary hover:bg-primary/20 transition-colors"
          >
            <Icon name="Plus" size={12} />
            <span>Добавить</span>
          </button>
        }
      >
        <div className="space-y-3">
          {(data?.offices || []).map((office, index) => (
            <div key={office.id || index} className="p-3 bg-muted rounded-lg space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-xs text-text-secondary">Кабинет {index + 1}</span>
                <button
                  onClick={() => removeOffice(index)}
                  className="p-1 hover:bg-error/10 hover:text-error rounded"
                >
                  <Icon name="Trash2" size={14} />
                </button>
              </div>

              <Input
                value={office._input || office.officeId || ''}
                onChange={(e) => updateOffice(index, e.target.value)}
                placeholder="ID кабинета или ссылка на него"
              />
              <p className="text-xs text-text-secondary">
                Откройте кабинет в админке → скопируйте ссылку из адресной строки
              </p>
              {office.officeId && office._input && office._input !== office.officeId && (
                <p className="text-xs text-primary flex items-center gap-1">
                  <Icon name="Check" size={12} />
                  ID: {office.officeId}
                </p>
              )}
            </div>
          ))}

          {(data?.offices || []).length === 0 && (
            <p className="text-sm text-text-secondary text-center py-4">
              Нет кабинетов. Нажмите "Добавить" чтобы создать.
            </p>
          )}
        </div>
      </SettingsGroup>
    </div>
  );
}
